import React, { useState, useEffect } from "react";
import Sidebar from "./Sidebar";

const Settings = () => {
  const [voltageLow, setVoltageLow] = useState(10);
  const [voltageHigh, setVoltageHigh] = useState(10);
  const [sag, setSag] = useState(10);
  const [swell, setSwell] = useState(10);
  const [batteryAlert, setBatteryAlert] = useState(true);
  const [maxAlerts, setMaxAlerts] = useState(10);
  const [alertWindow, setAlertWindow] = useState(5);

  useEffect(() => {
    // Load settings from backend
    fetch("/api/settings")
      .then(res => res.json())
      .then(data => {
        if (data.voltageThresholds) {
          const belowPct = Math.round(100 - (data.voltageThresholds.below / 120) * 100);
          const abovePct = Math.round((data.voltageThresholds.above / 120) * 100 - 100);
          setVoltageLow(belowPct);
          setVoltageHigh(abovePct);
        }
        if (data.sagSwell) {
          const sagPct = Math.round(100 - (data.sagSwell.sag / 120) * 100);
          const swellPct = Math.round((data.sagSwell.swell / 120) * 100 - 100);
          setSag(sagPct);
          setSwell(swellPct);
        }
        setBatteryAlert(data.batteryAlert);
        if (data.alertLimit) {
          setMaxAlerts(data.alertLimit.maxAlerts);
          setAlertWindow(data.alertLimit.alertWindowMinutes);
        }
      })
      .catch(err => {
        console.error("Failed to load settings:", err);
      });
  }, []);

  const handleSave = async () => {
    const settings = {
      voltageThresholds: {
        below: 120 - (120 * voltageLow / 100),
        above: 120 + (120 * voltageHigh / 100),
      },
      sagSwell: {
        sag: 120 - (120 * sag / 100),
        swell: 120 + (120 * swell / 100),
      },
      batteryAlert,
      alertLimit: {
        maxAlerts,
        alertWindowMinutes: alertWindow,
      },
    };

    try {
      const response = await fetch("/api/settings/save", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(settings)
      });

      if (response.ok) {
        alert("✅ Settings saved to backend.");
      } else {
        alert("❌ Failed to save settings.");
      }
    } catch (err) {
      console.error("Error saving settings:", err);
      alert("❌ Error saving settings.");
    }
  };

  return (
    <div style={{ display: "flex", height: "100vh", background: "#f7f7f7" }}>
      <Sidebar />
      <div style={{ flex: 1, padding: "2rem" }}>
        <h2>Settings</h2>
        <div
          style={{
            background: "#fff",
            padding: "2rem",
            borderRadius: "10px",
            maxWidth: "600px",
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
          }}
        >
          <h4>Voltage Thresholds (% from nominal)</h4>
          <div style={{ marginBottom: "1rem" }}>
            <label>Allowable drop below 120V (L-N): </label>
            <input
              type="number"
              value={Math.round(voltageLow)}
              onChange={(e) => setVoltageLow(parseFloat(e.target.value))}
              style={{ width: "60px", marginLeft: "1rem" }}
            />
            %
          </div>
          <div style={{ marginBottom: "1rem" }}>
            <label>Allowable rise above 120V (L-N): </label>
            <input
              type="number"
              value={Math.round(voltageHigh)}
              onChange={(e) => setVoltageHigh(parseFloat(e.target.value))}
              style={{ width: "60px", marginLeft: "1rem" }}
            />
            %
          </div>

          <h4>Sag & Swell Thresholds</h4>
          <div style={{ marginBottom: "1rem" }}>
            <label>Sag (% drop): </label>
            <input
              type="number"
              value={Math.round(sag)}
              onChange={(e) => setSag(parseFloat(e.target.value))}
              style={{ width: "60px", marginLeft: "1rem" }}
            />
          </div>
          <div style={{ marginBottom: "1rem" }}>
            <label>Swell (% rise): </label>
            <input
              type="number"
              value={Math.round(swell)}
              onChange={(e) => setSwell(parseFloat(e.target.value))}
              style={{ width: "60px", marginLeft: "1rem" }}
            />
          </div>

          <h4>Battery Monitoring</h4>
          <div style={{ marginBottom: "1rem" }}>
            <label>
              <input
                type="checkbox"
                checked={batteryAlert}
                onChange={(e) => setBatteryAlert(e.target.checked)}
                style={{ marginRight: "0.5rem" }}
              />
              Enable Battery Health Alerts
            </label>
          </div>

          <h4>SMS/Email Alert Limit</h4>
          <div style={{ marginBottom: "1rem" }}>
            <label>Max Alerts: </label>
            <input
              type="number"
              value={Math.round(maxAlerts)}
              onChange={(e) => setMaxAlerts(parseInt(e.target.value))}
              style={{ width: "60px", marginLeft: "1rem" }}
            />
          </div>
          <div style={{ marginBottom: "1rem" }}>
            <label>Per (minutes): </label>
            <input
              type="number"
              value={Math.round(alertWindow)}
              onChange={(e) => setAlertWindow(parseInt(e.target.value))}
              style={{ width: "60px", marginLeft: "1rem" }}
            />
          </div>

          <div style={{ display: "flex", justifyContent: "center", marginTop: "1rem" }}>
            <button
              onClick={handleSave}
              style={{
                padding: "10px 20px",
                backgroundColor: "#007bff",
                color: "#fff",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
                fontSize: "16px",
              }}
            >
              Save Settings
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
